var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 47.5,
    rx: 7.75,
    stroke: "#CA0814",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5703 17.8286H16.6275M16.6275 17.8286H33.0846M16.6275 17.8286V32.2286C16.6275 32.7742 16.8442 33.2975 17.23 33.6833C17.6158 34.069 18.139 34.2858 18.6846 34.2858H28.9703C29.5159 34.2858 30.0391 34.069 30.4249 33.6833C30.8107 33.2975 31.0275 32.7742 31.0275 32.2286V17.8286H16.6275ZM19.7132 17.8286V15.7715C19.7132 15.2259 19.9299 14.7027 20.3157 14.3169C20.7015 13.9311 21.2247 13.7144 21.7703 13.7144H25.8846C26.4302 13.7144 26.9534 13.9311 27.3392 14.3169C27.725 14.7027 27.9417 15.2259 27.9417 15.7715V17.8286M21.7703 22.9715V29.1429M25.8846 22.9715V29.1429",
    stroke: "#CA0814",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBasket);
export default __webpack_public_path__ + "static/media/deleteBasket.4235f30b3d410ca49434a979a4b04ad2.svg";
export { ForwardRef as ReactComponent };